import { Component, OnDestroy, OnInit } from '@angular/core';
import Highcharts from 'highcharts';
import { ChartService } from '../../core/services/chart/chart.service';
import { ChartDataObject } from '../../core/models/chart.model';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss'
})
export class UsersComponent implements OnInit, OnDestroy{
  chartConfig: Highcharts.Options | undefined;
  chartData!: ChartDataObject
  chartSeries: Highcharts.SeriesOptionsType[] = []
  loading = false;
  
  private subscriptions: Subscription = new Subscription();

  constructor(
    private chartService: ChartService, private translocoSrv: TranslocoService) {}

  ngOnInit() {
    this.subscriptions.add(
      this.translocoSrv.events$.subscribe(event => {
        if(event.type === 'translationLoadSuccess') {
          this.generateUserChart();
        } else {
          if(Object.keys(this.translocoSrv.getTranslation(this.translocoSrv.getActiveLang())).length) {
            this.generateUserChart();
          }
        }
    }));
    this.loading = true;
    this.subscriptions.add(
      this.chartService.loadUsersChartData().subscribe({
        next: () => {
          this.loading = false;
          this.generateUserChart();
        },
        error: () => {
          this.loading = false;
          this.generateUserChart();
        }
      })
    );
  }

  generateUserChart() {
    this.chartService.setUsersChartSeries();
    this.chartConfig = this.chartService.getUsersChartConfig();
  }
  
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}
